<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 16v2H8v-2zm4-4H8v2h8zm0-4H8v2h8zm3-5h-5V2h-4v1H5a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h7v-2H6V5h12v9h2V4a1 1 0 0 0-1-1m3 16h-1v-3h-2v3h-3v2h3v3h2v-3h3v-2z"/></svg>
</template>
